import {NavigateOptions, useNavigate, useSearchParams} from 'react-router-dom';

const whitelistedParams = ['forwardUrl', 'cetat', 'optin', 'isopenwebview'];

type GoBack = -1;

// Preserves search params when navigating to a new screen / page within the application.
export const useNavigateWithParams = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const cleanSearchParams = new URLSearchParams();
  searchParams.forEach((value, key) => {
    if (whitelistedParams.includes(key)) {
      cleanSearchParams.append(key, value);
    }
  });
  const searchString = cleanSearchParams.toString();

  return (path: string | GoBack, options?: NavigateOptions) => {
    if (path === -1) {
      // this still preserves search params
      return navigate(-1);
    }

    navigate(
      {
        pathname: path,
        search: searchString !== '' ? '?' + searchString : undefined,
      },
      {...options},
    );
  };
};
